import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { Subject, filter, map, mergeMap, takeUntil } from 'rxjs';
import { SeoService } from './seo-service'; // Adjust path as needed
import { AuthService } from './auth/auth-service';
import { CommonModule } from '@angular/common';
// import { RouterLink, RouterOutlet } from '@angular/router'

interface RouteData {
  title?: string;
  description?: string;
  url?: string;
  image?: string;
  video?: string | null;
}
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterLink, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})

export class App implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  isLoginPage: boolean = false;
  isAdmin: boolean = false;
  constructor(private router: Router, private route: ActivatedRoute, private seoService: SeoService, private auth: AuthService) {
  }

  ngOnInit() {
    this.auth.isAdmin().subscribe(isAdmin => {
      this.isAdmin = isAdmin;
    });
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let activeRoute = this.route;
        while (activeRoute.firstChild) {
          activeRoute = activeRoute.firstChild;
        }
        return activeRoute;
      }),
      mergeMap(route => route.data),
      takeUntil(this.destroy$)
    ).subscribe((data: RouteData) => {
      // Fallback values for missing metadata
      const title = data.title || 'Learning-Portal - Your Education Hub';
      const description =
        data.description || 'High-quality educational resources and tools at Learning-Portal.';
      const url = data.url || 'https://localhost:4200/';
      const image = data.image || 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png';
      const video = data.video || null;

      try {
        this.seoService.updatePageMeta(title, description, url, image);
      } catch (error) {
        console.error('Failed to update SEO metadata:', error);
      }
    });
  }

  logout() {
    this.auth.logout();
  }

  checkIsAdmin() {
    return this.auth.isAdmin();
  }


  // footer.component.ts
  scrollToTop() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
